import Pagination from '@mui/material/Pagination';

import { styled } from 'helpers';
import { Select } from 'Select';
import { MenuItem } from 'MenuItem';

import { PaginationProps } from '.';

export const StyledSpan = styled('span')`
  margin-right: 8px;
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  line-height: ${({ theme }) => theme.typography.pxToRem(20)};
  letter-spacing: 0.25px;
`;

export const StyledMenuItem = styled(MenuItem)`
  &.MuiMenuItem-root.MuiButtonBase-root {
    font-size: ${({ theme }) => theme.typography.pxToRem(14)};
    line-height: ${({ theme }) => theme.typography.pxToRem(20)};
    letter-spacing: 0.25px;
  }
`;

export const StyledSelect = styled(Select)`
  & .MuiSelect-select.MuiSelect-outlined.MuiOutlinedInput-input.MuiInputBase-input {
    padding: 6px 32px 6px 8px;
    font-size: ${({ theme }) => theme.typography.pxToRem(14)};
    line-height: ${({ theme }) => theme.typography.pxToRem(20)};
    letter-spacing: 0.25px;
  }
`;

export const StyledPagination = styled(Pagination)<PaginationProps>`
  display: inline-block;

  & .MuiPaginationItem-previousNext {
    border: none;
    color: ${({ theme }) => theme.palette.blueGrey.A600};
  }

  & .MuiPaginationItem-root.Mui-disabled {
    opacity: initial;
  }

  & .MuiPaginationItem-ellipsis {
    height: 20px;
    line-height: 1;
    font-weight: 800;
  }

  & .MuiButtonBase-root.MuiPaginationItem-root {
    border: none;
    font-size: ${({ theme }) => theme.typography.pxToRem(16)};
    height: 36px;
    min-width: 36px;
    border-radius: 20px;
    margin: 0 4px;
    line-height: ${({ theme }) => theme.typography.pxToRem(24)};
    letter-spacing: 0.5px;

    &:hover {
      background-color: ${({ theme }) => theme.palette.grey.A50};
    }

    &.Mui-selected {
      background: none;
      border: 1px solid ${({ theme }) => theme.palette.blue[800]};
      color: ${({ theme }) => theme.palette.blue[800]};
    }

    &:active,
    &.Mui-focusVisible {
      background-color: ${({ theme }) => theme.palette.blue[50]};
    }

    .MuiSvgIcon-root.MuiPaginationItem-icon {
      font-size: 1.6rem;
    }
  }
`;
StyledPagination.displayName = 'Pagination';
